import React, { useState, useEffect, useRef } from 'react';
export default function StripNumbers(props) {
    var fields = props.fields, children = props.children;
    var useAnimatedNumber = function (target, startAnimation) {
        var _a = useState(0), value = _a[0], setValue = _a[1];
        useEffect(function () {
            if (!startAnimation)
                return;
            var start = 0;
            var duration = 1000;
            var increment = Math.ceil(target / (duration / 20));
            var timer = setInterval(function () {
                start += increment;
                if (start >= target) {
                    setValue(target);
                    clearInterval(timer);
                }
                else {
                    setValue(start);
                }
            }, 20);
            return function () { return clearInterval(timer); };
        }, [target, startAnimation]);
        return value;
    };
    return (React.createElement("div", { className: "strip spa-strip-number "
            + fields.backgroundColor
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "") },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row" }, children && children.map(function (child) { return (React.createElement(NumberItem, { key: child.id, child: child })); })))));
    function NumberItem(_a) {
        var child = _a.child;
        var ref = useRef(null);
        var _b = useState(false), startAnimation = _b[0], setStartAnimation = _b[1];
        useEffect(function () {
            var observer = new IntersectionObserver(function (_a) {
                var entry = _a[0];
                if (entry.isIntersecting) {
                    setStartAnimation(true);
                    observer.unobserve(entry.target);
                }
            }, { threshold: 0.5 });
            if (ref.current)
                observer.observe(ref.current);
            return function () { return observer.disconnect(); };
        }, []);
        var animatedNumber = useAnimatedNumber(child.fields.number, startAnimation);
        return (React.createElement("div", { ref: ref, className: "col-md-4 mb-4" },
            React.createElement("div", { className: "number-item" },
                React.createElement("div", { className: "number display-2 mb-3" }, animatedNumber),
                React.createElement("div", { className: "sub-element d-flex align-items-center gap-2" },
                    child.fields.icon && React.createElement("div", { className: "img-container" },
                        React.createElement("img", { className: 'icon', src: child.fields.icon, title: child.fields.icon_title, alt: child.fields.icon_description })),
                    child.fields.title &&
                        React.createElement("div", { className: "title h6 mb-0" }, child.fields.title)))));
    }
}
